export const GET_ALL_CONTENT = 'GET_ALL_CONTENT';